jQuery(document).ready(function( $ ) {

// Custom JS functions
    if($('.modal-covid')[0]){
        $('.modal-covid button.close').click(function() {
            console.log('clicked close');
            $('.modal-covid').css({'display':'none'});
        });
    }
    
    //reveal phone in header
    if($('.reveal-phone')[0]) {
    $('.reveal-phone').click(function() {
        if($('.hidden-phone').css('display') == 'none') {
            $('.hidden-phone').css({'display':'inline-block'});
        } else {
            $('.hidden-phone').css({'display':'none'});
        }
    });
    //hide phone if mouse outside div
    $('.hidden-phone').mouseleave(function(){
        $('.hidden-phone').css({'display':'none'});
    });
    }
    
    
    
    //disable phone link mobile on coupons
    $('.coupon-container').each(function() {
        $(this).find('.primary-btn').attr('x-ms-format-detection', 'none'); 
    });
    
    //scroll to id
    /*$('a[href*="#"]').click(function(e){
        e.preventDefault()
        $('html, body').animate({
            scrollTop: $($(this).attr('href')).offset().top - $('header').height(),
        }, 500, 'linear');
        if($(this).parents('.show').length) {
            $('.navbar-collapse').removeClass('show');
        }
    });*/
    
    
    //expand-content 
    $('.expand-link').click(function() {
       $(this).siblings('.expand-content').slideToggle();
    });
    
    //parallax rotate
    /*$(window).scroll(function() {
    var theta = $(window).scrollTop();
        $('.parallax-rotate').css({ transform: 'rotate(' + theta + 'deg)' });
    });**/
    
    
    //fix parallax bkg
    $(window).trigger('resize').trigger('scroll');
    
    //progresss bar 
    /*$(window).scroll(function () {
    var s = $(window).scrollTop();
    var d = $(document).height();
    var c = $(window).height();
    var scrollPercent = (s / (d-c)) * 100;
    var position = scrollPercent;

    $("#progressbar").attr('value', position);

    });
    
    //detect page top
    if($('.header-style-3-nav')[0]) {    
        $(window).load(function() {
            if ($(window).scrollTop() >= .001) {
                $('.header-style-3-nav').addClass('scrolling');
            } else {
                $('.header-style-3-nav').removeClass('scrolling');
            }
        });
        $(window).scroll(function() {
            if ($(window).scrollTop() >= .001) {
                $('.header-style-3-nav').addClass('scrolling');
            } else {
                $('.header-style-3-nav').removeClass('scrolling');
            }
        });
    }
    
    if($('.header-style-4-nav.scroll-up')[0]) {
        var top = $('.header-style-4-topbar').height();
        var distance = $('.header-style-4-nav.scroll-up').offset().top - top;
        $(window).scroll(function() {
            if ($(window).scrollTop() >= distance) {
                $('.header-style-4-nav.scroll-up').css({'position':'fixed', 'top': top });
            } else {
                $('.header-style-4-nav.scroll-up').css({'position':'relative', 'top': 0});
            }
        });
    }
    */
    
    //accordion 
    if($('.accordion')[0]) {
        $('.accordion-heading').click(function() {
            console.log('clicked');
            $('.accordion-content').slideUp();
            $(this).siblings('.accordion-content').slideDown();
        });
    }
    
    if($('.hero-bkg-slider, .absolute-slider')[0]){
    $('.hero-bkg-slider, .absolute-slider').slick({
        dots: false,
        arrows: false,
        infinite: true,
        speed: 1500,
        fade: true,
        cssEase: 'linear',
        autoplay: true,
        pauseOnHover:false,
        pauseOnFocus:false,
        autoplaySpeed: 8000,
    }); 
    }
    
    if($('.reviews-slick')[0]) {
    $('.reviews-slick').slick({
        dots: false,
        arrows: false,
        infinite: true,
        speed: 300,
        fade: true,
        cssEase: 'linear',
        autoplay: true,
        adaptiveHeight: true,
        autoplaySpeed: 5000,
        nextArrow: '<i class="fas fa-arrow-right"></i>',
        prevArrow: '<i class="fas fa-arrow-left"></i>',
    }); 
    }
    
    if($('.specials-slick')[0]) {
    $('.specials-slick').slick({
        dots: false,
        infinite: true,
        speed: 200,
        fade: true,
        cssEase: 'linear',
        autoplay: false,
        pauseOnHover:false,
        pauseOnFocus:false,
        autoplaySpeed: 3500,
        arrows: true,
        slidesToShow: 1,
        adaptiveHeight:true,
        slidesToScroll: 1,
        nextArrow: '<i class="fas fa-arrow-right"></i>',
        prevArrow: '<i class="fas fa-arrow-left"></i>',
    });
    }
    $('.services-slick').slick({
      dots: false,
      infinite: true,
      nextArrow: '<i class="fas fa-chevron-right"></i>',
      prevArrow: '<i class="fas fa-chevron-left"></i>',
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay:true,
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        } ],
    });
    
    if($('.gallery-slick')[0]) {
    $('.gallery-slick').slick({
        dots: false,
        infinite: true,
        speed: 200,
        fade: true,
        cssEase: 'linear',
        autoplay: false,
        pauseOnHover:false,
        pauseOnFocus:false,
        autoplaySpeed: 3500,
        arrows: true,
        slidesToShow: 1,
        adaptiveHeight:true,
        slidesToScroll: 1,
        nextArrow: '<i class="fas fa-arrow-right"></i>',
        prevArrow: '<i class="fas fa-arrow-left"></i>',
    });
    }
    
    if($('.gallery-thumb-slider')[0]) {
    $('.gallery-thumb-slider').slick({
        nextArrow: '<i class="fas fa-arrow-right"></i>',
        prevArrow: '<i class="fas fa-arrow-left"></i>',
        draggable: false,
        swipe: false,
        swipeToSlide: false,
        touchMove: false,
        adaptiveHeight:true,
    });
    }
    
    /*$('.gallery-thumb-slider').slickLightbox({
        itemSelector: '.lightbox-img',
    });*/
    
    if($(".thumbnails img")[0]) {
    $(".thumbnails img").click(function(e){
        e.preventDefault();
        var slideIndex = $(this).parent().index();
        $( '.gallery-thumb-slider' ).slick('slickGoTo', slideIndex);
        
        $('html, body').animate({
            scrollTop: $('#gallery').offset().top - $('header').height(),
        }, 500, 'linear');
        
    });
    }
    
    function toggleDropdown (e) {
      var d = $(this);
      var m = $($(this).find('.dropdown-menu')[0]);
      console.log($(this));
      setTimeout(function(){
        var shouldOpen = e.type !== 'click' && d.is(':hover');
        m.toggleClass('show', shouldOpen);
        d.toggleClass('show', shouldOpen);
        $('[data-toggle="dropdown"]', d).attr('aria-expanded', shouldOpen);
      }, e.type === 'mouseleave' ? 50 : 0);
    }
    
    $(window).on('load resize', function() {
        $('body').on('mouseenter mouseleave','.dropdown',toggleDropdown);     
    });
    
    /*$(window).on('load',function() {
        if(window.location.hash) {
            var hash = window.location.hash;
            console.log(hash);
            $('html, body').animate({
                scrollTop: $(hash).offset().top - ($('header').height() + 175),
            }, 500, 'linear');
        }
    });*/
    // parallax
    /*var parallax = document.getElementsByClassName('parallax-element');
    new simpleParallax(parallax, {
        overflow: true,
        transition: 'cubic-bezier(0,0,0,1)',
    });*/
});


// WEBPACK FOOTER //
// ./scripts/mta.js